module.exports = __webpack_public_path__ + "img/suchen.a1b1abf3.svg";